import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Ticket, Users } from "lucide-react";
import BackButton from "@/components/BackButton";

export default function Friends() {
  const [refs, setRefs] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/dashboard/referrals");
        setRefs(data.referrals);
      } catch {}
    })();
  }, []);

  const totalInvested = refs.reduce((s, r) => s + r.investment_amount, 0);
  const totalTickets = refs.reduce((s, r) => s + r.tickets_earned, 0);
  const active = refs.filter((r) => r.status === "aktivan").length;

  return (
    <div className="p-4 md:p-8 space-y-6" data-testid="friends-page">
      <div className="flex justify-end mb-4"><BackButton /></div>
      <div>
        <p className="text-xs uppercase tracking-[0.4em] text-zinc-500">Lista referala</p>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-wide mt-1">
          Pozvani <span className="text-neon-orange">prijatelji</span>
        </h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Ukupno" value={refs.length} color="#fff" />
        <Stat label="Aktivnih" value={active} color="#22ff77" />
        <Stat label="Tokeni osvojeni" value={totalTickets} color="#22ff77" />
        <Stat label="Ulog prijatelja" value={`€${totalInvested.toFixed(0)}`} color="#ff7a18" />
      </div>

      <div className="nasa-card overflow-hidden">
        <div className="flex items-center gap-2 p-6 border-b border-white/5">
          <Users className="w-4 h-4 text-[#22ff77]" />
          <h2 className="font-display text-lg">Svi pozvani</h2>
        </div>
        {refs.length === 0 ? (
          <div className="p-10 text-center text-zinc-500 text-sm">
            Još uvek nemate pozvanih prijatelja. Idite na <strong>Pozovi prijatelje</strong> da podelite svoj link.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 border-b border-white/5">
                  <th className="text-left px-6 py-3">#</th>
                  <th className="text-left px-6 py-3">Ime</th>
                  <th className="text-left px-6 py-3">Email</th>
                  <th className="text-left px-6 py-3">Datum</th>
                  <th className="text-left px-6 py-3">Status</th>
                  <th className="text-right px-6 py-3">Ulog</th>
                  <th className="text-right px-6 py-3">Tokeni</th>
                </tr>
              </thead>
              <tbody>
                {refs.map((r, i) => (
                  <tr key={r.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                    <td className="px-6 py-4 text-zinc-500">{String(i + 1).padStart(2, "0")}</td>
                    <td className="px-6 py-4">{r.name}</td>
                    <td className="px-6 py-4 text-zinc-400 text-xs">{r.email}</td>
                    <td className="px-6 py-4 text-zinc-400 text-xs font-mono">
                      {new Date(r.joined_at).toLocaleDateString("sr-Latn-RS")}
                    </td>
                    <td className="px-6 py-4">
                      <span className={`text-[10px] uppercase tracking-widest px-2 py-1 rounded-sm border ${
                        r.status === "aktivan"
                          ? "text-[#22ff77] border-[#22ff77]/40 bg-[#22ff77]/5"
                          : "text-[#ff7a18] border-[#ff7a18]/40 bg-[#ff7a18]/5"
                      }`}>
                        {r.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right font-mono">{r.investment_amount.toFixed(2)} €</td>
                    <td className="px-6 py-4 text-right">
                      <span className="inline-flex items-center gap-1 text-[#22ff77] font-bold">
                        <Ticket className="w-3.5 h-3.5" /> {r.tickets_earned}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

function Stat({ label, value, color }) {
  return (
    <div className="border border-white/10 bg-black/40 p-4 rounded-sm">
      <div className="text-[10px] uppercase tracking-widest text-zinc-500">{label}</div>
      <div className="font-display text-3xl font-bold mt-1" style={{ color }}>{value}</div>
    </div>
  );
}
